module.exports = __webpack_public_path__ + "img/D14-turkey.1f761292.png";